module.exports = __webpack_public_path__ + "static/media/Layla.4322a175.png";